import { Injectable } from '@angular/core';
import CustomStore from 'devextreme/data/custom_store';
import { EntityQuery, iBisEntityService } from '@dohu/ibis-entity';
import { iBisAuthService, iBisSecureEditService } from '@dohu/ibis-auth';
import { iBisLanguageService, iBisServerConfig } from '@dohu/ibis-common';
import { AuthDetailsService } from '../../../common/auth-details/auth-details.service';
import notify from 'devextreme/ui/notify';
import { ProxyService } from '../../../service/proxy.service';
@Injectable({
    providedIn: 'root'
})
export class FilterPatientService extends iBisSecureEditService {
    public data = [];
    public sex: { id: number; value: string }[];
    public ageRange: { id: number; value: string }[];
    public doctors: any[] = []
    public selectedSpecializations: string[] = [];

    constructor(auth: iBisAuthService, entity: iBisEntityService, config: iBisServerConfig, lg: iBisLanguageService, private ad: AuthDetailsService
    ) {
        super(auth, entity, config, lg);
        this.title = 'FILTER_PATIENT';
        this.validation = 'FilterPatientValidation';
    }

    protected load(): void {
        this.sex = this.GetSexes();
        this.ageRange = this.getAgeRanges()
        this.ad.partyUserDataLoadedSubject.subscribe(_ => {

        });
    }

    createDefault(): any {
        return { specializations: [], userIds: [] };
    }
    getById(id: string): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve({});
            /*  this.entity.getById('Procedure', id).then((obj) => {
                 if (obj) {
                     resolve(obj);
                 } else {
                     reject();
                 }
             }, error => this.lg.showError(error)); */
        });
    }
    onRemove(id: string): Promise<void> {
        return this.entity.remove('Patient', id);
    }
    onSaveEv(serverUrl?: string): Promise<any> {
        return this.entity.save('Patient', this.model.id, this.model);
    }
    reset(): void {
        this.model = this.createDefault();
    }

    private GetSexes(): { id: number; value: string }[] {
        return [{ id: 1, value: 'Masculin' }, { id: 2, value: 'Feminin' }];
    }

    private getAgeRanges(): { id: number; value: string }[] {
        return [
            { id: 1, value: '0-14' },
            { id: 2, value: '15-24' },
            { id: 3, value: '25-34' },
            { id: 4, value: '35-44' },
            { id: 5, value: '45-54' },
            { id: 6, value: '55-64' },
            { id: 7, value: '65+' }
        ];
    }

    public getDoctorsBySpec(specializationIds: string[]) {
        /* const doctorRoleIdQ = new EntityQuery('UserLoginRole').eq('name', 'doctor').link('groupId', 'id', new EntityQuery('EnumValue')
            .linkEq('typeId', 'id', 'EnumType', 'name', 'ROLE_GROUP'));


         this.entity.single(doctorRoleIdQ, this.config.saasServer).then((doctorRole: any) => { */

        const q = new EntityQuery('UserSpecialization').in('specializationId', specializationIds)
            // const q = new EntityQuery('PartyUser').eq('roleId', doctorRole.id)
            .eq('partyId', this.ad.authDetails.party.id)
        // .addOrderBy(['orderIndex']);

        //q.link('userId', 'userId', new EntityQuery('UserSpecialization')
        //.eq('partyId', this.ad.authDetails.party.id)
        //.in('specializationId', specializations));



        this.entity.load(q).then((userSpecs: any[]) => {
            this.selectedSpecializations = userSpecs.map(us => {
                const spec = this.model.specializations.find((s: any) => s.id === us.specializationId);
                return {
                    ap_userId: us.userId,
                    ...us,
                    ...spec || null
                };
            });
            console.log(this.selectedSpecializations, 'userSpecs');
            const qq = new EntityQuery('UserLogin').eq('isActiv', true)
                .in('id', userSpecs.map(cd => cd.userId));
            this.entity.store(qq, false, 'id', this.config.saasServer).load().then((resultedDoctors: any[]) => {
                const groupedDoctorsBySpec = Object.entries(
                    resultedDoctors.reduce((acc, doctor) => {
                        const specializationName = this.model.specializations.find(spec => spec.id === userSpecs.find(cd => cd.userId === doctor.id)?.specializationId)?.description || 'Unknown';
                        if (!acc[specializationName]) {
                            acc[specializationName] = [];
                        }
                        acc[specializationName].push(doctor);
                        return acc;
                    }, {})
                ).map(([key, items]) => ({ key, items }));
                console.log(groupedDoctorsBySpec, 'groupedDoctorsBySpec');
                this.doctors = groupedDoctorsBySpec;
            }, (error: any) => this.doctors = [])
        });
        //  });
    }


    public generateData(e: any): void {
        const validation = e.validationGroup.validate();
        if (!validation.isValid) {
            notify(this.L('ALL_REQ_FIELDS'), 'warning', 3000);
            return;
        }
        const q = new EntityQuery('Patient').eq('isActiv', true).addOrderBy(['lastName']);
        const finishedApp = new EntityQuery('AppointmentView')
            .eq('ap.statusId', 5).lte('startDate', this.model.dueDate).gte('startDate', this.model.fromDate);
        if (this.model.userIds && this.model.userIds.length) {
            finishedApp.in('ap.userId', this.model.userIds)
        }
        q.link('id', 'ap.patientId', finishedApp);
        this.entity.store(finishedApp, false, 'ap_id').load().then((res: any) => {
            console.log(res, 'programari')
            const patientIds = res.map((e: any) => e.ap_patientId);
            q.in('id', patientIds);
            this.entity.store(q, false, 'id').load().then((patients: any[]) => {
                console.log(patients, 'pacienti initiali')
                const filteredPatients = this.filterPatientsByGenderAndAge(patients);
                const enrichedAppointments = res.filter((appointment: any) =>
                    filteredPatients.some((patient: any) => patient.id === appointment.ap_patientId)
                ).reduce((acc: any[], appointment: any) => {
                    appointment['specialization'] = this.selectedSpecializations.find((spec: any) => spec.ap_userId === appointment.ap_userId)?.['description'] || '';
                    const patientData = filteredPatients.find((patient: any) => patient.id === appointment.ap_patientId);
                    const existingEntry = acc.find(entry => entry.ap_userId === appointment.ap_userId && entry.ap_patientId === appointment.ap_patientId);

                    if (existingEntry) {
                        existingEntry.consultationCount += 1;
                    } else {
                        acc.push({ ...appointment, ...patientData, consultationCount: 1 });
                    }

                    return acc;
                }, []);
                this.data = enrichedAppointments || [];
            }, error => this.lg.showError(error));
        });
    }


    filterPatientsByGenderAndAge(patients: any[]) {
        const filteredPatients = patients.filter(patient => {
            if (patient.cnp) {
                const { age, monthsOld, gender } = this.extractAgeAndGender(patient.cnp);
                const genderMatch = !this.model.sex || gender === this.model.sex;
                const [minAge, maxAge] = this.model.ageRange ? this.model.ageRange.split('-').map(Number) : [0, 0];
                const ageMatch = (minAge === 0 && maxAge === 0) || (age >= minAge && age <= maxAge);
                patient.age = age === 0
                    ? `${monthsOld} ${monthsOld === 1 ? 'lună' : 'luni'}`
                    : `${age} ${age === 1 ? 'an' : 'ani'}`;
                patient.gender = this.sex.find(s => s.id === gender)?.value || '';
                return genderMatch && ageMatch;
            }
        })
        console.log(filteredPatients, 'pacienti filtrati')
        return filteredPatients

    }

    extractAgeAndGender(cnp: string): { age: number, monthsOld: number, gender: 1 | 2 } {
        const s = parseInt(cnp.charAt(0), 10);
        const yearPart = parseInt(cnp.substr(1, 2), 10);
        const month = parseInt(cnp.substr(3, 2), 10) - 1; // Month is 0-indexed in JS
        const day = parseInt(cnp.substr(5, 2), 10);

        let fullYear = 1900 + yearPart;
        if (s === 5 || s === 6) fullYear = 2000 + yearPart;

        const birthDate = new Date(fullYear, month, day);
        const today = new Date();

        let age = today.getFullYear() - birthDate.getFullYear();
        if (
            today.getMonth() < birthDate.getMonth() ||
            (today.getMonth() === birthDate.getMonth() && today.getDate() < birthDate.getDate())
        ) {
            age--;
        }

        let monthsOld = (today.getFullYear() - birthDate.getFullYear()) * 12 + today.getMonth() - birthDate.getMonth();
        if (today.getDate() < birthDate.getDate()) {
            monthsOld--;
        }

        const gender = (s % 2 === 1) ? 1 : 2;

        return { age, monthsOld, gender };
    }


    private getData(): CustomStore {
        const q = new EntityQuery('Procedure').addOrderBy(['code']);
        return this.entity.store(q);
    }
}
